import { render } from "./btnHoras.vue?vue&type=template&id=1381cfe6"
import script from "./btnHoras.vue?vue&type=script&lang=js"
export * from "./btnHoras.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/monitor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__